import * as R from 'ramda'

// like R.update but keep array padding
export const updateAt = R.curry((index, value, traversable) => {
  const newTraversable = R.clone(traversable)
  newTraversable[index] = value
  return newTraversable
})
// R.update(2, true, []) //=> []
// updateAt(2, true, []) //=> [undefined, undefined, true]
